import { ImageIcon } from '@primer/octicons-react';
import { Button } from '@primer/react';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { RenderViewNetImpactLensParams } from '@upright/common/renderer/component-types/types-render-view-lenses';
import {
  RenderItem,
  RenderOptions,
  RenderViewComponentParams,
  RenderViewComponentType,
} from '@upright/common/renderer/types';
import { RenderViewButton } from '@upright/ui/common/generic/misc/render-view-button';
import { getVersionAndRelease } from '@upright/ui/untidy/redux/selectors';
import { useSelector } from 'react-redux';
import { getLens } from '../../../impact-lenses';
import { NetImpactLensData } from '../../../impact-lenses/net-impact/types';
import { LensSelectionStates } from '../../../impact-lenses/selection-hook';
import { useCarouselContext } from '../../context';
import { LensData, LensOptions } from '../../types';

export const DownloadImageButton = () => {
  const context = useCarouselContext();
  const { release, version } = useSelector(getVersionAndRelease);

  return (
    <RenderViewButton
      initialOptions={getRenderOptionsForLens(context.data, version, release, context.selectionState, context.options)}
      button={<DownloadButton />}
    />
  );
};

const DownloadButton = () => (
  <Button variant="invisible" size="small" sx={{ fontSize: '11px' }} leadingVisual={ImageIcon}>
    Download image
  </Button>
);

function getRenderOptionsForLens<T extends ImpactLensType>(
  lensData: LensData<T>,
  version: string,
  release: string | null,
  selectionState: LensSelectionStates[T],
  options: LensOptions<T>,
): Partial<RenderOptions> {
  const optionsBase: Pick<RenderOptions, 'showControlUi' | 'version' | 'release' | 'width'> = {
    version,
    release,
    showControlUi: true,
    width: 1000,
  };
  const lensType = lensData.type;
  const entity = lensData.entity;
  if (!entity) return {};

  const item: RenderItem = {
    index: 0,
    resultId: (lensData as NetImpactLensData).modelResultId,
    type: entity.type,
    id: entity.id,
    name: entity.name,
  };

  const selectionStateString = getLens(lensType).serializeSelectionState(selectionState);

  const params: RenderViewComponentParams = (() => {
    switch (lensType) {
      case ImpactLensType.UPRIGHT_NET_IMPACT: {
        const p: RenderViewNetImpactLensParams = {
          componentType: RenderViewComponentType.LENS_NET_IMPACT,
          order: 0,
          selectionState: selectionStateString || '',
          item,
          scoreUnit: options.scoreUnit,
        };
        return p;
      }
      default:
        throw Error('Not implemented');
    }
  })();
  return { ...optionsBase, componentParams: [params] };
}
